// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/custom/user/info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/custom/custom/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/custom/custom/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录接口 POST /api/custom/iam/login */
export async function Imslogin(body: API.ImsLoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/custom/iam/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录获取验证码 GET /client/custom/personal/sms/send/login */
export async function getCode(params: { [key: string]: any }) {
  return request<API.LoginResult>('/api/custom/personal/sms/send/login', {
    method: 'GET',
    params: {
      ...params
    }
  });
}

/** 验证码登录 GET /client/custom/custom/sms/login */
export async function codeLogin(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/custom/custom/sms/login', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
  });
}

/** 注册 POST /scm/custom-user/register */
export async function registerFrom(body: API.registerParams, options?: { [key: string]: any }) {
  return request<any>('/api/custom/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注册短信 POST /public/sms/register */
export async function mobileCode(body?:{mobile: string }) {
  return request<any>('/api/custom/public/sms/register', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
/** 产品列表 GET /client/oms/spu/detail/list */
export async function clientSpu(options?: { [key: string]: any }) {
  console.log(options,'options');
  
  return request<Record<string, any>>('/api/oms/spu/detail/list', {
    method: 'GET',
    params: {
      ...(options || {}),
    },
  });
}

/** 创建订单 POST /client/oms/create/order */
export async function createOrder(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/oms/create/order', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

/** 区域列表 /client/ims/region/list */
export async function regionList(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/ims/region/list', {
    method: 'GET',
    params: {
      ...(options || {}),
    },
  });
}

export async function findPayStatus(orderId: String) {
  return request('/api/oms/order/payStatus', {
    method: 'GET',
    params: { orderId }
  });
}

/** 按钮权限 POST /client/custom/menu */
export async function customButton() {
  return request('/api/custom/menu', {
    method: 'GET'
  });
}

/** 菜单权限 POST /client/custom/user/menu */
export async function menuAuth(params: any) {
  return request('/api/custom/user/menu', {
    method: 'GET',
    params
  });
}

/** webShell POST /client/cloud/pod/ssh/ticket */
export async function getTicket(options?: { [key: string]: any }) {
  return request<any>('/api/cloud/pod/ssh/ticket', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

/** 顶级节点列表 POST /client/ims/specs/top */
export async function getSpecsList(options?: { [key: string]: any }) {
  return request<any>('/api/ims/specs/top', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

/** 1:普通用户-找回密码-返回前端邮箱和手机号 GET /client/custom/public/retrieve/password */
export async function retrievePwd(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/retrieve/password', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 2:邮箱验证码-密码找回 GET /client/custom/public/retrieve/email */
export async function retrieveEmail(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/retrieve/email', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 2:手机验证码-密码找回-返回一串随机字符，确认修改密码的时候把这串字符串用code参数传入 GET /client/custom/public/retrieve/sms */
export async function retrieveSms(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/retrieve/sms', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 2:手机验证码 GET /client/custom/personal/sms/send/retrieve */
export async function getRetrieveCode(options?: { [key: string]: any }) {
  return request<any>('/api/custom/personal/sms/send/retrieve', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 3:确认修改密码 GET /client/custom/public/retrieve/affirm */
export async function retrieveAffirm(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/retrieve/affirm', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 平台申请 GET /client/custom/public/apply/using */
export async function applyusing(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/apply/using', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

/** 平台申请短信 GET /client/custom/public/sms/apply */
export async function smsapplyusing(options?: { [key: string]: any }) {
  return request<any>('/api/custom/public/sms/apply', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 平台请求报警记录/client/cloud/alarm/log/page */
export async function queryAlarmRecordPageList(params: any, options?: any) {
  return request('/api/cloud/alarm/log/page', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 子用户查询主账户/client/custom/custom/login/examine */
export async function customExamine(params: any, options?: any) {
  return request<any>('/api/custom/custom/login/examine', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}